import { useEffect, useMemo, useState } from "react";
import { DEFAULT_LIST_PAGE_SIZE } from "../lib/listPagination";

/** Client-side pagination for in-memory lists (e.g. dropdown options per group). */
export function useClientPagination(rows, pageSize = DEFAULT_LIST_PAGE_SIZE) {
  const [page, setPage] = useState(1);

  useEffect(() => {
    setPage(1);
  }, [rows.length, pageSize]);

  const meta = useMemo(() => {
    const count = rows.length;
    const total_pages = count ? Math.ceil(count / pageSize) : 0;
    return { count, page, page_size: pageSize, total_pages };
  }, [rows.length, page, pageSize]);

  const pagedRows = useMemo(() => {
    const start = (page - 1) * pageSize;
    return rows.slice(start, start + pageSize);
  }, [rows, page, pageSize]);

  return {
    rows: pagedRows,
    meta,
    page,
    setPage,
    pagination: {
      meta,
      pageSize,
      onPageChange: setPage,
    },
  };
}
